import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})


// Usage: {{ someText | truncate(100) }}
Vue.filter('truncate', function (value, limit = 100) {
  if (!value) return ''
  value = value.toString()
  return value.length > limit ? value.slice(0, limit) + '...' : value
})